/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const __vue_script__ = {

  /** @since 3.8.7 */
  name: "downloadformats",

  data() {
    return {
      download_format:     this.config.downloads[0].format,
      down_with_relations: false,
      downloads_formats:   [...this.config.downloads],
    }
  },
  props: {
    featureIndex: {
      type: Number,
    },
    feature: {
      type: Object
    },
    layer: {
      type: Object
    },
    config: {
      type: Object,
      default: null
    },
  },
  watch: {
    down_with_relations(bool) {
      //In case of download relation is checked
      if (bool) {
        //filter download formats without pdf because it isn't possible download relation in pdf format
        this.downloads_formats = this.downloads_formats.filter(({ format }) => 'pdf' !== format);
      }
      //If checked download relation and current dowload format is pdf, need to set another format
      if (bool && 'pdf' === this.download_format) {
        this.download_format   =  this.downloads_formats[0].format;
      }
      //in case of no checked downloa relations, get all formats
      if (!bool) {
        this.downloads_formats = [...this.config.downloads];
      }
    }
  },
  methods: {
    async download() {
      try {
        const download = this.config.downloads.find(action => action.format === this.download_format);
        await download.cbk(
          this.layer,
          this.feature
            ? this.feature
            : this.layer.features,
          download,
          this.featureIndex,
          'pdf' === download.format
            ? document.querySelector(`[feature-html-content="${this.layer.id}_${this.featureIndex}"]`).innerHTML
            : null,
          Number(this.down_with_relations),  //@since 3.11.7 Convert boolean to 0/1
        );
      }
      catch(e) { console.warn(e); }
    }
  },
}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.layer.hasdownloadablerelations)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.down_with_relations),expression:"down_with_relations"}],staticClass:"magic-checkbox",attrs:{"id":("g3w-download-relations_" + _vm.featureIndex),"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.down_with_relations)?_vm._i(_vm.down_with_relations,null)>-1:(_vm.down_with_relations)},on:{"change":function($event){var $$a=_vm.down_with_relations,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.down_with_relations=$$a.concat([$$v]))}else{$$i>-1&&(_vm.down_with_relations=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.down_with_relations=$$c}}}}),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('sdk.relations.download_with_relations'),expression:"'sdk.relations.download_with_relations'"}],attrs:{"for":("g3w-download-relations_" + _vm.featureIndex)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"g3w-download-formats-content",staticStyle:{"width":"100%","display":"flex"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();}}},[_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('download_format'),expression:"'download_format'"}],staticClass:"form-control",staticStyle:{"flex-grow":"1"},attrs:{"search":false}},_vm._l((_vm.downloads_formats),function(download){return _c('option',{directives:[{name:"download",rawName:"v-download"}],key:download.id,domProps:{"value":download.format}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(download.format))])])}),0),_vm._v(" "),_c('button',{directives:[{name:"download",rawName:"v-download"}],staticClass:"btn skin-button",staticStyle:{"border-radius":"0 3px 3px 0"},on:{"click":function($event){$event.stopPropagation();return _vm.download.apply(null, arguments)}}},[_c('span',{class:_vm.g3wtemplate.getFontClass('download')})])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "QueryResultsActionDownloadFormats.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__